import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Constants, AlertService } from 'src/app/shared';
import { SiteService } from 'src/app/services/index';
import * as ObjectUtils from 'util';

@Component({
  selector: 'app-add-dcu',
  templateUrl: './add-dcu.component.html',
  styleUrls: ['./add-dcu.component.scss']
})
export class AddDcuComponent implements OnInit, AfterViewInit, OnDestroy {
  addDCUForm: FormGroup;
  dcuDetails: any;
  sites: any;
  availableDCUName: any;
  isSiteSelected: boolean;
  isDuplicatedDCUName: boolean;

  constructor(private fb: FormBuilder, private siteService: SiteService,
    private alertService: AlertService) {
    this.availableDCUName = [];
    
    this.resetdcu();
  }

  ngOnInit() {
    this.resetdcu();
    this.addDCUForm = this.fb.group({
      dcuMakeCtr: [''],
      dcuNameCtr: [''],
      dcuSerialNumberCtr: [''],
      siteCtr: ['', [Validators.required]],
      firmWareVersionCtr: ['']
    });

    this.siteService.getAllSites().subscribe(data => {
      if(!ObjectUtils.isNullOrUndefined(data)) {
        this.sites = data;
      }
    });
  }

  siteSelectionChanged(event) {
    if (event && event !== '') {
      this.isSiteSelected = true;
      this.availableDCUName = [];

      this.siteService.getAllDCUBySiteId(this.dcuDetails.siteId).subscribe(data => {
        if(!ObjectUtils.isNullOrUndefined(data)) {
          data.forEach(element => {
            this.availableDCUName.push(element.dcuName.toLowerCase());
          });
          this.checkDuplicatedDCUName();
        }
      });
    } else {
      this.isSiteSelected = false;
      this.availableDCUName = [];
    }
  }

  checkDuplicatedDCUName() {
    this.isDuplicatedDCUName = this.dcuDetails.dcuName && this.dcuDetails.dcuName.length > 0 ? this.availableDCUName.includes(this.dcuDetails.dcuName.toLowerCase()) : false;
    if (this.isDuplicatedDCUName) {
      this.addDCUForm.get('dcuNameCtr').setErrors({ 'duplicated': true });
    } else {
      const error = this.addDCUForm.get('dcuNameCtr').getError('duplicated');
      if (error) {
        this.addDCUForm.get('dcuNameCtr').setErrors(null);
      }
    }
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
  }

  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.addDCUForm.get(fieldName).hasError(errorCode);
  }

  submitDCUDetails() {
    const dcu = {
      'dcuMake': this.dcuDetails.dcuMake,
      'dcuName': this.dcuDetails.dcuName,
      'dcuSerialNumber': this.dcuDetails.dcuSerialNumber.toString(),
      'siteId': this.dcuDetails.siteId,
      'firmwareVersion' : this.dcuDetails.firmWareVersion
    };
    this.siteService.saveDCU(dcu).subscribe(data => {
      if (data === true) {
        this.dcuDetails.EntryFailureMessage = Constants.BOOLEAN_FALSE;
        this.dcuDetails.submitted = Constants.BOOLEAN_TRUE;
        this.alertService.showSuccess(Constants.MESSAGE.Save_success);
        setTimeout(() => {
          this.resetdcu();
        }, 10000);
      } else {
        this.alertService.showError(Constants.MESSAGE.Save_failure);
        this.dcuDetails.EntryFailureMessage = Constants.BOOLEAN_TRUE;
      }
    });
  }

  resetdcu() {
    this.isSiteSelected = false;
    this.isDuplicatedDCUName = false;
    this.dcuDetails = {
      dcuMake: '',
      dcuName: '',
      dcuSerialNumber: '',
      submitted: Constants.BOOLEAN_FALSE,
      DuplicateEntryErrorMessage: Constants.BOOLEAN_FALSE,
      EntryFailureMessage: Constants.BOOLEAN_FALSE,
      siteId: '',
      firmWareVersion: ''
    };
  }
}
